import { IconDefinition } from '@fortawesome/fontawesome-common-types'

const HealthHero: IconDefinition = {
	// @ts-ignore
	prefix: "",
	// @ts-ignore
	iconName: "healthHero",
	icon: [
		38.1, // Width
		47, // Height
		["", ""], // Ignore
		"", // Ignore
		"M6.5,13.2c3.6,0,6.5-2.9,6.5-6.6c0-3.6-2.9-6.6-6.5-6.6C2.9,0,0,3,0,6.6C0,10.2,2.9,13.2,6.5,13.2M31.6,0c-3.6,0-6.5,2.9-6.5,6.6s2.9,6.6,6.5,6.6c3.6,0,6.5-3,6.5-6.6C38.1,3,35.2,0,31.6,0zM6.5,33.7c-3.6,0-6.5,2.9-6.5,6.6c0,3.6,2.9,6.6,6.5,6.6c3.6,0,6.5-3,6.5-6.6C13.1,36.7,10.2,33.7,6.5,33.7zM31.6,33.7c-3.6,0-6.5,2.9-6.5,6.6c0,3.6,2.9,6.6,6.5,6.6c3.6,0,6.5-3,6.5-6.6C38.1,36.7,35.2,33.7,31.6,33.7zM31.6,16.9c-2.1,0-3.2,0.6-5.1,2.5c-3.6,3.8-11.1,3.8-14.8,0.1c-1.5-1.4-3.1-2.5-5.1-2.5c-3.6,0-6.5,2.9-6.5,6.6S2.9,30,6.5,30c2.1,0,3.5-1,5.1-2.5c3.6-3.8,11.1-3.8,14.8,0c1.7,1.7,3.1,2.5,5.1,2.5c3.6,0,6.5-3,6.5-6.6C38.1,19.8,35.2,16.9,31.6,16.9",
	],
};
export default HealthHero;